import { v4 as uuidv4 } from 'uuid';
import i18n from '../../../i18n';
import { MarketingBonusCalculatorView } from './MarketingBonusCalculatorView';

const t = (value: string) => i18n.t('sidePanel.' + value)

export const MarketingBonusCalculatorTab = (): ITab => {
    return {
        id: uuidv4(),
        title: t('service.submenu.marketingBonusCalculator'),
        plugin: 'marketing_bonus_calculator_plugin',
        view: {
            content: <MarketingBonusCalculatorView />
        }
    }
}